import * as React from 'react';
import {
  ArrowButtons,
  Breakpoints,
  BreakpointWrapper,
  Gallery as VWGallery,
  GalleryContext,
  GallerySlide as VWGallerySlide,
  Lentils,
} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import {
  GalleryProps,
  GallerySlideProps,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

interface GoToComponentPros {
  gotoSlide?: number;
}
function GoToComponent({gotoSlide}: GoToComponentPros): JSX.Element {
  const {triggerChange} = React.useContext(GalleryContext);

  React.useEffect(() => {
    triggerChange(gotoSlide || 0);
  }, []);
  React.useEffect(() => {
    triggerChange(gotoSlide || 0);
  }, [gotoSlide]);

  return <></>;
}

export function Gallery({
  ariaLabel,
  children,
  goToSlide,
  isTariffV5,
  isContentLayer,
}: GalleryProps): JSX.Element {
  return (
    <VWGallery
      id="tariffs-gallery"
      slidesPerPage={{
        [Breakpoints.default]: 1,
        [Breakpoints.b960]: 2,
        [Breakpoints.b1280]: isContentLayer ? 2 : 3,
      }}
      bottomElements={
        <>
          <BreakpointWrapper min={Breakpoints.b960}>
            <ArrowButtons
              buttonPreviousAriaLabel="To previous slide"
              buttonNextAriaLabel="To next slide"
            />
          </BreakpointWrapper>
          <BreakpointWrapper
            max={children.length > 3 ? undefined : Breakpoints.b1280}
          >
            <LentilsWrapper>
              <Lentils />
            </LentilsWrapper>
          </BreakpointWrapper>
          <GoToComponent gotoSlide={goToSlide} />
        </>
      }
      fadingEdges={isTariffV5 ? 'normal' : undefined}
      aria-label={ariaLabel}
    >
      {children}
    </VWGallery>
  );
}

export function GallerySlide({
  ariaLabelledby,
  key,
  children,
}: GallerySlideProps): JSX.Element {
  return (
    <VWGallerySlide key={key} aria-labelledby={ariaLabelledby}>
      {children}
    </VWGallerySlide>
  );
}

const LentilsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${(props) => props.theme.size.static250};
`;
